import AxiosAPI from '../../utils/AxiosAPI';

export default null;

// Path: src/projects/app/API/Components/ApiPageProvider.jsx

// Get API URLs

export const handleAllControllersRoutes = (params) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/list/routes`, { ...params })
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
